var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.itemClassName,on:{"click":_vm.onClick}},[_c('div',{staticClass:"inner"},[_c('CountryFlag',{attrs:{"country":_vm.iso,"size":"normal"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }